import React from 'react';

export default function PageActionRow({
  children,
  className = '',
  label = 'Azioni principali della pagina',
  ...props
}) {
  return (
    <div
      className={['wt-page-action-row', className].filter(Boolean).join(' ')}
      role="group"
      aria-label={label}
      {...props}
    >
      {children}
    </div>
  );
}
